export default __webpack_public_path__ + "static/media/czechgo-screenshot-02.73d07941.png";